import { render, staticRenderFns } from "./block-other-party-vehicle.vue?vue&type=template&id=dbcb3958&scoped=true&"
import script from "./block-other-party-vehicle.vue?vue&type=script&lang=js&"
export * from "./block-other-party-vehicle.vue?vue&type=script&lang=js&"
import style0 from "./block-other-party-vehicle.vue?vue&type=style&index=0&id=dbcb3958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb3958",
  null
  
)

export default component.exports